module.exports = __webpack_public_path__ + "assets/img/00065.e697c9fe.png";